import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Product, QRCodeBatch } from 'src/app/types/types';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-new-redeem-request',
  templateUrl: './new-redeem-request.component.html',
  styleUrls: ['./new-redeem-request.component.scss']
})
export class NewRedeemRequestComponent implements OnInit {

  form: FormGroup;
  
  constructor(private fb: FormBuilder,private http: HttpClient,private toastrService: ToastrService) { }

  ngOnInit() {
    this.form = this.fb.group({
      mobileNumber:['',[Validators.required]],
      qrCode:['',[Validators.required]]
    });
  }
  
  onSubmit(){
  
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    let postUrl = `${environment.serverUrl}/redeem-request/add/new`
    
    this.http.post(postUrl, JSON.stringify(this.form.value)).subscribe({
          next: (result:any) => {
            console.log(result)
            Swal.fire({
              title: "Success",
              html: result.message,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#0379A5',
              confirmButtonText: 'Ok',
            })
          },
          error: (e) => {
            console.error(e);
            Swal.fire({
              title: "Error",
              html: e.error,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#0379A5',
              confirmButtonText: 'Ok',
            })
          },
          complete: () => console.info('complete')
        });
  }

}
